import { render, staticRenderFns } from "./DocsDetailNamespace.vue?vue&type=template&id=d9ea5948&"
import script from "./DocsDetailNamespace.vue?vue&type=script&lang=js&"
export * from "./DocsDetailNamespace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports